import React from "react";
import LegalPage from "./LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy">
      <p>
        Knight Insurance Solutions respects your privacy. This policy explains what
        information we collect when you visit our website or request a quote, how we use
        it, and how we protect it.
      </p>
      <h2 className="text-xl font-semibold text-slate-900 mt-8">Information we collect</h2>
      <p>
        When you submit a quote or contact request, we collect the information you
        provide (such as name, email, phone number, and details about the coverage you
        are seeking). We do not sell your personal information.
      </p>
      <h2 className="text-xl font-semibold text-slate-900 mt-8">How we use it</h2>
      <p>
        We use your information solely to respond to your request, to prepare and present
        carrier quotes, and to communicate with you about your policy. We may share your
        information with the insurance carriers needed to provide a quote.
      </p>
      <h2 className="text-xl font-semibold text-slate-900 mt-8">Contact</h2>
      <p>
        Questions? Email{" "}
        <a className="underline" href="mailto:damon.knight@knightinssolutions.com">
          damon.knight@knightinssolutions.com
        </a>{" "}
        or call 1 (888) 93-KNIGHT.
      </p>
    </LegalPage>
  );
}
